import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import CreateOfficeForm from "../Forms/CreateOfficeForm";

interface CreateOfficeModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel?: () => void;
}

export const CreateOfficeModal: FC<CreateOfficeModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <CreateOfficeForm
        width={750}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};
